export default theme => ({
    twoColInner: {
        position: 'relative',
        marginBottom: 36,
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            fontFamily: theme.headerFont,
            fontSize: 32,
            letterSpacing: '0.048em',
            lineHeight: '1.25',
            marginTop: 0,
            marginBottom: 36,
            [theme.breakpoints.up('md')]: {
                paddingRight: 90,
                fontSize: 48,
                lineHeight: 1.15,
            }
        },
        '& > p': {
            fontSize: 14,
            letterSpacing: '0.024em',
            lineHeight: '2',
            [theme.breakpoints.up('md')]: {
                paddingRight: 90,
            }
        },
        '& > .gatsby-image-wrapper': {
            width: 'calc(100% + 34.8px)',
            margin: '0 -17.4px',
            [theme.breakpoints.up('md')]: {
                width: '100%',
                margin: '0 0 32px',
            }
        }
    },
    twoColInnerTheme: {
        ...theme.twoColInnerTheme,
    }
})